module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-9.516d18d1.jpg";